// ---------------------------------------------------------------------------
// Sync Highlight Slice — ephemeral cross-tab sync highlight state.
//
// Stores IDs highlighted by selection in other tabs:
//   - syncedFlowIds: Flow names highlighted by Page element selection (SYNC-01)
//   - syncedElementIds: Element IDs highlighted by Data entity selection (SYNC-03)
//   - syncedEntityIds: Entity IDs highlighted by Flow selection (SYNC-02)
//   - syncedOntologyNodeIds: Ontology node IDs for Data graph (SYNC-02)
//
// Written to by MCP notification bus subscribers (useNotificationSync).
// Read by UI components for amber highlight rendering.
// ---------------------------------------------------------------------------

export interface SyncHighlightSlice {
  syncedFlowIds: Set<string>
  syncedElementIds: Set<string>
  syncedEntityIds: Set<string>
  syncedOntologyNodeIds: Set<string>

  setSyncedFlowIds: (ids: Set<string>) => void
  setSyncedElementIds: (ids: Set<string>) => void
  setSyncedEntityIds: (ids: Set<string>) => void
  setSyncedOntologyNodeIds: (ids: Set<string>) => void
  clearAllSyncHighlights: () => void
}

type Set_ = (fn: (state: SyncHighlightSlice) => void) => void

export function createSyncHighlightSlice(
  set: Set_,
  _get: unknown,
  _api: unknown,
): SyncHighlightSlice {
  return {
    syncedFlowIds: new Set<string>(),
    syncedElementIds: new Set<string>(),
    syncedEntityIds: new Set<string>(),
    syncedOntologyNodeIds: new Set<string>(),

    setSyncedFlowIds: (ids) => set((s) => { s.syncedFlowIds = ids }),
    setSyncedElementIds: (ids) => set((s) => { s.syncedElementIds = ids }),
    setSyncedEntityIds: (ids) => set((s) => { s.syncedEntityIds = ids }),
    setSyncedOntologyNodeIds: (ids) => set((s) => { s.syncedOntologyNodeIds = ids }),
    clearAllSyncHighlights: () => set((s) => {
      s.syncedFlowIds = new Set()
      s.syncedElementIds = new Set()
      s.syncedEntityIds = new Set()
      s.syncedOntologyNodeIds = new Set()
    }),
  }
}
